export const CONFIG = {
  "PROJECTNAME": "ekomarkt",
  "COMPANYNAME": "Ekomarkt",
  "DFTLNGCODE": "nl",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10207001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#518D4B",
    "primary100": "#bff5cd",
    "light": "#518D4B",
    "secondary": "#518D4B",
    "dark": "#383838",
    "siteColor3": "#fff",
    "menuSecondary": "#518D4B"
  }
};